module.exports = __webpack_public_path__ + "img/project-management.725b03c8.svg";